import { gql } from "@apollo/client";

import { groupDetailsListItemV2Fragment } from "../../../groups/api/fragments";

export const createGroupV2 = gql`
    mutation createGroupV2($name: String!, $organizationId: String = null) {
        selectedOrganization @client {
            id @export(as: "organizationId")
        }
        saveGroupV2(input: { name: $name, organizationId: $organizationId }) {
            ...GroupDetailsListItemV2
        }
    }
    ${groupDetailsListItemV2Fragment}
`;
